import React from "react";

import { Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./components/Home";
import PrivacyPolicy from "./components/PrivacyPolicy";

import About from "./pages/About";
import Contact from "./pages/Contact";

import WashingMachineService from "./pages/WashingMachine";
import ACService from "./pages/ACService";
import FridgeService from "./pages/FridgeService";
import MicrowaveService from "./pages/MicrowaveService";
import TVService from "./pages/TVService";
import WaterHeater from "./pages/WaterHeater";
import WaterPurifier from "./pages/WaterPurifier";

import "./App.css";
import TermsCondition from "./components/TermsCondition";
import ScrollToTop from "./components/ScrollToTop";
import RefundPolicy from "./components/RefundPolicy";

function App() {

  return (

    <>

      <Navbar />
<ScrollToTop />
      <Routes>

        <Route
          path="/"
          element={<Home />}
        />

        <Route
          path="/about"
          element={<About />}
        />

        <Route
          path="/contact"
          element={<Contact />}
        />

        <Route
          path="/washing-machine-service"
          element={<WashingMachineService />}
        />

        <Route
          path="/ac-service"
          element={<ACService />}
        />

        <Route
          path="/fridge-service"
          element={<FridgeService />}
        />

        <Route
          path="/microwave-service"
          element={<MicrowaveService />}
        />

        <Route
          path="/tv-service"
          element={<TVService />}
        />

        <Route
          path="/water-heater-service"
          element={<WaterHeater />}
        />

        <Route
          path="/water-purifier-service"
          element={<WaterPurifier />}
        />

        <Route
          path="/privacy-policy"
          element={<PrivacyPolicy />}
        />

          <Route
          path="/terms-condition"
          element={<TermsCondition />}
        />

        <Route
  path="/refund-policy"
  element={<RefundPolicy />}
/>

      </Routes>

      {/* FLOATING CALL BUTTON */}

      <a
        href="tel:+919363929984"
        className="call-button"
      >

        📞

      </a>

      <Footer />

    </>

  );
}

export default App;